import { observer } from 'mobx-react-lite'
import { type OCRScopingJobMainPanelViewModel } from '@/features/jobs/scoping/OCRScopingJobMainPanelViewModel'
import { OCRScopeJobDetailFooter } from '@/features/jobs/scoping/components/OCRScopeJobDetailFooter'

export interface OCRScopeJobDetailFooterContainerProps {
  vm: OCRScopingJobMainPanelViewModel
}

export const OCRScopeJobDetailFooterContainer = observer(
  function OCRScopeJobDetailFooterContainer({
    vm,
  }: OCRScopeJobDetailFooterContainerProps) {
    if (!vm.hasScopeWork || vm.isScopingInProgress) {
      return null
    }
    if (!vm.canManageOCRScopingJobs && !vm.isReadyToSubmit) {
      return null
    }

    return (
      <OCRScopeJobDetailFooter
        archived={vm.selectedScopeWork.archived}
        isPending={vm.isPending}
        isErrorOccurred={vm.isErrorOccurred}
        isUnderReview={vm.isUnderReview}
        isReadyToSubmit={vm.isReadyToSubmit}
        canSubmitJob={vm.canSubmitJob}
        onDelete={vm.confirmArchive}
        onRerun={vm.rerun}
        onLinkManually={vm.openLinkManuallyDialog}
        onSetReadyToSubmit={vm.confirmReview}
        onSubmit={vm.confirmSubmit}
      />
    )
  },
)
